import { ReasonsData } from "../../../constant/data"

const WhyUseSafeLockerSection =()=>{
    return (
        <section
                id="why-use-safelocker"
                className="px-5 sm:px-10 xl:px-20 mt-24 w-full "
              >
                <div className="flex  bmd:justify-center w-full">
                  <div className="flex bmd:flex-row w-full flex-col bmd:items-center xl:w-[90%] ">
                    <div className="bmd:w-[60%]">
                      <img
                        src="images/safelocker.svg"
                        width={"90%"}
                        alt="safelocker"
                        className="xl:block rounded hidden"
                      />
                      <img
                        src="images/safelocker.svg"
                        width={"99%"}
                        height={80}
                           alt="safelocker"
                        className="xl:hidden rounded sm:h-[440px] block "
                      />
                    </div>
                    <div>
                      <h3 className="md:text-[32px] bmd:mt-0 mt-5 text-[24px] text-[#0E1728] font-worksans">
                        Why Use SafeLockers
                      </h3>
                      <div className="mt-7 space-y-5">
                        {ReasonsData.map((data) => (
                          <div key={data.id}>
                            <div className="flex space-x-2">
                              <img src="images/iconoir.svg" alt="list-icon" />
                              <p className="font-onest text-[#464748] text-base bmd:text-[18px]">
                                {data.title}
                              </p>
                            </div>
                            <span className="font-onest text-[#464748] text-sm bmd:text-base">
                              {data.content}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
    )
}

export default WhyUseSafeLockerSection